import { Stack } from "@mui/material";
import React from "react";
import Card1 from "./Card1";
import Card2 from "./Card2";
import Card3 from "./Card3";
import Card4 from "./Card4";
import Card5 from "./Card5";

import Card6 from "./Card6";
import Card7 from "./Card7";
import BottomSection from "./BottomSection";
import Introduction101 from "../../ThirdMainSection/IntroSection/Introduction101";
import IntroductionSection from "./IntroductionSection";
import MobileCardComponent from "./MobileCardComponent";

const FirstSectionII = () => {
  return (
    <Stack
      sx={{
        backgroundColor: "white",
        display: "flex",
        flexDirection: "column",
        // border: "1px solid red",
      }}
    >
      <Stack
        sx={{
          display: { xl: "flex", lg: "flex" },
          flexDirection: { xl: "row", lg: "row", sm: "row" },
          justifyContent: "center",
          // border: "2px solid green",
          marginBottom: { xl: "0px", lg: "0px", md: "40px" },
        }}
      >
        <Stack
          sx={{
            // border: "2px solid red",
            width: { xl: "72%", lg: "86%", md: "86%", sm: "70%" },
          }}
        >
          <IntroductionSection />
        </Stack>
      </Stack>
      {/* For desktop */}
      <Stack
        sx={{
          // width: { xl: "72%", lg: "86%", md: "86%", sm: "70%" },
          display: {
            xl: "flex",
            lg: "flex",
            md: "flex",
            sm: "flex",
            xs: "none",
          },
          flexDirection: "row",
          justifyContent: "center",
          alignItems: "center",
          // border: "2px solid green",
        }}
      >
        <Stack
          sx={{
            display: { xl: "flex", lg: "flex" },
            flexDirection: { xl: "row", lg: "row", sm: "row" },
            justifyContent: "center",
            // alignItems: "center",
            width: { xl: "100%", lg: "100%", md: "91%", sm: "70%" },
            // border: "1px solid red",
            gap: { xl: 2, lg: 2, sm: 2 },
            paddingTop: { xl: "64px", lg: "80px" },
            paddingBottom: { xl: "20px", lg: "8px" },
            paddingLeft: {
              xl: "0px",
              lg: "0px",
              md: "0px",
              sm: "0px",
              xs: "12px",
            },
            paddingRight: {
              xl: "0px",
              lg: "0px",
              md: "0px",
              sm: "0px",
              xs: "12px",
            },
          }}
        >
          <Stack
            sx={{
              width: { xl: "19%", lg: "20%", sm: "30%" },
              height: { xl: "670px", lg: "632px", md: "630px", sm: "520px" },
              marginBottom: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "12px",
              },
              // border: "1px solid red",
              marginTop: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "12px",
              },
              display: {
                xl: "flex",
                lg: "flex",
                md: "flex",
                sm: "flex",
                xs: "none",
              },
            }}
          >
            <Card1 />
          </Stack>

          <Stack
            sx={{
              width: { xl: "19%", lg: "20%", sm: "30%" },
              height: { xl: "670px", lg: "632px", md: "630px", sm: "520px" },
              marginBottom: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "12px",
              },
              // border: "1px solid red",
              marginTop: {
                xl: "0px",
                lg: "0px",
                md: "0px",
                sm: "0px",
                xs: "12px",
              },
              display: {
                xl: "none",
                lg: "none",
                md: "none",
                sm: "none",
                xs: "flex",
              },
            }}
          >
            <Card2 />
          </Stack>
          <Stack
            sx={{
              // border: "1px solid red",
              width: { xl: "52%", lg: "64%", sm: "64%" },
              display: "flex",
              flexDirection: { xl: "column" },
              gap: { xl: 2, lg: 1, sm: 2 },
              height: { xl: "657px", lg: "640px", sm: "520px" },
            }}
          >
            <Stack
              sx={{
                height: { xl: "50%", lg: "50%", sm: "59%" },
                // border: "1px solid red",
                display: "flex",
                flexDirection: { xl: "row", lg: "row", sm: "row" },
                gap: { xl: 2, lg: 2, sm: 2 },
                // border: "1px solid green",
              }}
            >
              <Stack
                sx={{
                  width: { xl: "49%", lg: "50%", sm: "50%" },

                  marginBottom: {
                    xl: "0px",
                    lg: "0px",
                    md: "0px",
                    sm: "0px",
                    xs: "12px",
                  },
                }}
              >
                <Card3 />
              </Stack>
              <Stack
                sx={{
                  width: { xl: "49%", lg: "50%", sm: "50%" },
                  // border: "1px solid green",
                  marginBottom: {
                    xl: "0px",
                    lg: "0px",
                    md: "0px",
                    sm: "0px",
                    xs: "12px",
                  },
                }}
              >
                <Card4 />
              </Stack>
            </Stack>

            <Stack
              sx={{
                // border: "1px solid green",
                height: { xl: "50%", lg: "50%", sm: "59%" },
                // border: "1px solid red",
                display: "flex",
                flexDirection: { xl: "row", lg: "row", sm: "row" },
                gap: { xl: 2, lg: 2, sm: 2 },
              }}
            >
              <Stack
                sx={{
                  width: { xl: "49%", lg: "50%", sm: "50%" },

                  marginBottom: {
                    xl: "0px",
                    lg: "0px",
                    md: "0px",
                    sm: "0px",
                    xs: "12px",
                  },
                }}
              >
                <Card5 />
              </Stack>
              <Stack
                sx={{
                  width: { xl: "49%", lg: "50%", sm: "50%" },
                  marginBottom: {
                    xl: "0px",
                    lg: "0px",
                    md: "0px",
                    sm: "0px",
                    xs: "12px",
                  },
                }}
              >
                <Card6 />
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      </Stack>
      {/* for desktop */}
      <BottomSection />
      {/* for mobile */}
      <MobileCardComponent />
    </Stack>
  );
};

export default FirstSectionII;
